import { Form, Input, InputNumber } from "antd";
import React from "react";

const TotalMaleCount: React.FC = () => {
  return (
    <Form.Item
      name="malePopulation"
      label="Total Males"
      rules={[
        {
          required: true,
          message: "Please enter the total male count",
        },
      ]}
    >
      <InputNumber
        changeOnWheel={false}
        controls={false}
        style={{ width: "100%" }}
      />
    </Form.Item>
  );
};

export default TotalMaleCount;
